import { InputNumber } from 'antd';
import { GrispiInputProps } from '..';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiIntegerInputProps = Omit<GrispiInputProps<'NUMBER_INTEGER'>, 'type' | 'options' | 'isNewValueAllowed'>;

const GrispiIntegerInput = ({ antdProps, containerProps, onChange, value, ...rest }: GrispiIntegerInputProps) => {
    return (
        <GrispiInputContainer {...containerProps}>
            <InputNumber
                {...antdProps}
                inputMode="numeric"
                onChange={onChange}
                precision={0}
                step={1}
                type="number"
                value={value}
                onKeyDown={(e) => [',', '.', 'e'].includes(e.key) && e.preventDefault()} //prevent to 'e'
                {...rest}
            />
        </GrispiInputContainer>
    );
};

export default GrispiIntegerInput;
